export default function initMarcasSlider() {
    const mainSlider = document.querySelector('.js-marcas-main-slider');
    const navSlider = document.querySelector('.js-marcas-nav-slider');

    if (!mainSlider || !navSlider) return;

    const marcasNav = new Swiper(navSlider, {
        slidesPerView: 2.2,
        spaceBetween: 10,
        freeMode: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true, 
        breakpoints: {
            768: {
                slidesPerView: 5,
                spaceBetween: 20,
            }
        },
    });

    const marcasMain = new Swiper(mainSlider, {
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        autoHeight: true,
        pagination: {
            el: '.c-marcas__progress',
            type: 'progressbar',
        },
        thumbs: {
            swiper: marcasNav
        },
        a11y: {
            prevSlideMessage: 'Marca anterior',
            nextSlideMessage: 'Próxima marca',
        }
    });

}
